export const GET_QUESTS_REQUEST = 'GET_QUESTS_REQUEST';
export const GET_QUESTS_SUCCESS = 'GET_QUESTS_SUCCESS';
export const GET_QUESTS_FAILURE = 'GET_QUESTS_FAILURE';
export const POST_LOG_REQUEST = 'POST_LOG_REQUEST';
export const POST_LOG_SUCCESS = 'POST_LOG_SUCCESS';
export const POST_LOG_FAILURE = 'POST_LOG_FAILURE';
export const SET_QUEST_VIEWED_REQUEST = 'SET_QUEST_VIEWED_REQUEST';
export const SET_QUEST_VIEWED_SUCCESS = 'SET_QUEST_VIEWED_SUCCESS';
export const SET_QUEST_VIEWED_FAILURE = 'SET_QUEST_VIEWED_FAILURE';
